import Vue from 'vue'
import VueRouter from 'vue-router'
import AppLogin from '@/views/AppLogin.vue'
import UserInvite from "@/views/admin/InviteUser/UserInvite.vue";
import UserList from "@/views/admin/user/UserList.vue";
import Profile from '../views/Profile.vue'
import AdminLayout from "@/views/admin/AdminLayout";
import InvitationResponse from "@/views/InvitationResponse";
import InviteUserList from "@/views/admin/InviteUser/InviteUserList";
import CustomerInviteList from "@/views/admin/CustomerInvite/CustomerInviteList.vue";
import CustomerInviteCreate from "@/views/admin/CustomerInvite/CustomerInviteCreate.vue";
import BrandList from "@/views/admin/brands/index.vue";
import NotificationsList from "@/views/NotificationsList.vue";
import LocationList from "@/views/admin/location/LocationList.vue";
import LocationForm from "@/views/admin/location/LocationForm.vue";
import ActionIndex from "@/views/admin/actions/index.vue";
import ActionCreate from "@/views/admin/actions/create.vue";
import ActionEdit from "@/views/admin/actions/update.vue";
import ProductList from "@/views/admin/products/ProductList.vue";
import ProductForm from "@/views/admin/products/ProductForm.vue";
import HotelList from "@/views/admin/Hotel/HotelList.vue";
import HotelForm from "@/views/admin/Hotel/HotelForm.vue";
import ServiceList from '@/views/admin/services/ServiceList.vue';
import ServiceForm from '@/views/admin/services/ServiceForm.vue';
import ProductServiceList from "@/views/admin/productService/ProductServiceList.vue";
import ProductServiceCreate from "@/views/admin/productService/ProductServiceCreate";
import Integrations from '@/views/admin/integrations/index.vue';
import IntegrationCreate from "@/views/admin/integrations/create.vue";
import IntegrationUpdate from "@/views/admin/integrations/update.vue";
import IntegrationUsers from "@/views/admin/integrationUsers/index.vue";
import CustomerList from '@/views/admin/customer/CustomerList.vue';
import ActionUserCreate from '@/views/admin/actionUsers/create.vue';
import PreCheckinForm from '../view/PreCheckinForm.vue';
import AddBooking from '@/views/admin/preCheckin/AddBooking.vue';
import Bookings from '@/views/admin/preCheckin/Index.vue';
import PreCheckinThankYou from '../view/PreCheckinThankYou.vue';
import RoomTypeList from '@/views/admin/Hotel/RoomTypeList.vue';
import RoomTypeForm from '@/views/admin/Hotel/RoomTypeForm.vue';
import BedSizeList from '@/views/admin/Hotel/BedSizeList.vue';
import BedSizeForm from '@/views/admin/Hotel/BedSizeForm.vue';
import FacilityList from '@/views/admin/Hotel/FacilityList.vue';
import FacilityForm from '@/views/admin/Hotel/FacilityForm.vue';
import RoomFacilityList from '@/views/admin/Hotel/RoomFacilityList.vue';
import RoomFacilityForm from '@/views/admin/Hotel/RoomFacilityForm.vue';
import HotelFacilityList from '@/views/admin/Hotel/HotelFacilityList.vue'
import HotelFacilityForm from '@/views/admin/Hotel/HotelFacilityForm.vue'
import DepartmentList from '@/views/admin/Department/DepartmentList.vue'
import DepartmentForm from '@/views/admin/Department/DepartmentForm.vue'
import StaffList from '@/views/admin/Staff/StaffList.vue'
import StaffForm from '@/views/admin/Staff/StaffForm.vue'
import StaffDashboard from '@/views/StaffDashboard.vue'

import RoomAvailability from '@/views/admin/roomAvailability/Index.vue';
import AddRoomAvailability from '@/views/admin/roomAvailability/Create.vue';
import EditRoomAvailability from '@/views/admin/roomAvailability/Create.vue';
import CreateRoom from '@/views/admin/rooms/create.vue';
import EditRoom from '@/views/admin/rooms/edit.vue';
import Rooms from '@/views/admin/rooms/index.vue';
import Coupon from '@/views/admin/coupon/Index.vue';
import AddCoupon from '@/views/admin/coupon/Create.vue';
import EditCoupon from '@/views/admin/coupon/Create.vue';
import OfferList from '@/views/admin/Offers/OfferList.vue';
import OfferForm from '@/views/admin/Offers/OfferForm.vue';
import OfferDetail from '@/views/admin/Offers/OfferDetail.vue';
import HotelGroupList from '@/views/admin/hotelGroup/Index.vue';
import HotelGroupForm from '@/views/admin/hotelGroup/Create.vue';
import ReportsIndex from '@/views/admin/reports/ReportsIndex.vue';
import BillingList from '@/views/admin/billing/BillingList.vue';
import UserLayout from '@/components/user/layout/UserLayout.vue';
import UserHome from '@/views/user/Home.vue';
import UserHotels from '@/views/user/Hotels.vue';
import UserHotelDetails from '@/views/user/HotelDetails.vue';
import UserBookings from '@/views/user/Bookings.vue';
import AboutUs from '@/views/user/AboutUs.vue';
import ContactUs from '@/views/user/ContactUs.vue';
import PrivacyPolicy from '@/views/user/PrivacyPolicy.vue';
import PreCheckinChat from "@/views/admin/preCheckin/Chat.vue";
import PreCheckinOffersList from "@/views/admin/PreCheckinOffers/PreCheckinOffersList.vue";
import bookingcom from "@/views/admin/Booking.com/booking.vue";
import navigationItems from '@/navigation/navigationItems';
import { getAuthUser, hasAuthUser } from '@/Util/auth';
import store from '@/store';


Vue.use(VueRouter)

const routes = [
  {
    path: '/user/google-callback',
    component: () => import('@/views/user/GoogleCallback.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: AppLogin,
    meta: { requiresAuth: false }
  },
  {
    path: '/pre-checkin/:id',
    name: 'PreCheckinForm',
    component: PreCheckinForm,
    meta: { requiresAuth: false }
  },
  // { path: "/users/create", component: UserInvite },
  // { path: "/users", component: UserList },
  {
    path: '/users/create',
    name: 'AdminUserCreate',
    component: UserInvite,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/admin',
    component: AdminLayout,
    meta: { requiresAuth: true, requiresAdmin: true },
    children: [
          {
            path: 'dashboard',
            name: 'AdminDashboard',
            component: () => import('@/views/admin/AppDashboard.vue'),
            meta: { requiresAuth: true, requiresAdmin: true }
          },
          {
            path: 'profile',
            component: Profile,
            name:'AdminProfile',
            meta: {
              requiresAuth: true,
              title: 'Profile',
            }
          },
          {
            path: 'users',
            name: 'AdminUsers',
            component: UserList,
            meta: { requiresAuth: true, requiresAdmin: true }
          },
          {
            path: 'invite-users',
            name: 'AdminInviteUsers',
            component: InviteUserList,
            meta: { requiresAuth: true, requiresAdmin: true }
          },
          {
            path: 'users/invite',
            name: 'AdminUserInvite',
            component: UserInvite,
            meta: { requiresAuth: true, requiresAdmin: true }
          },
          {
            path: 'customer-invites',
            name: 'AdminCustomerInvites',
            component: CustomerInviteList,
            meta: { requiresAuth: true, requiresAdmin: true }
          },
          {
            path: 'customer-invites/create',
            name: 'AdminCustomerInviteCreate',
            component: CustomerInviteCreate,
            meta: { requiresAuth: true, requiresAdmin: true }
          },
          {
            path: 'brands',
            name: 'AdminBrands',
            component: BrandList,
            meta: {
              requiresAuth: true,
              title: 'Brands'
            }
          },
          {
            path: 'settings',
            name: 'AdminSettings',
            component: () => import('@/views/admin/AppSettings.vue'),
            meta: { requiresAuth: true, requiresAdmin: true }
          },
          {
            path: 'locations',
            name: 'AdminLocations',
            component: LocationList,
            meta: { requiresAuth: true, requiresAdmin: true }
          },
          {
            path: 'locations/create',
            name: 'AdminLocationCreate',
            component: LocationForm,
            meta: { requiresAuth: true, requiresAdmin: true }
          },
          {
            path: 'locations/:id/edit',
            name: 'AdminLocationEdit',
            component: LocationForm,
            props: route => ({ id: route.params.id }),
            meta: { requiresAuth: true, requiresAdmin: true }
          },
          {
            path: 'products',
            name: 'AdminProducts',
            component: ProductList,
            meta: { requiresAuth: true, requiresAdmin: true }
          },
          {
            path: 'products/create',
            name: 'AdminProductCreate',
            component: ProductForm,
            meta: { requiresAuth: true, requiresAdmin: true }
          },
          {
            path: 'products/:id/edit',
            name: 'AdminProductEdit',
            component: ProductForm,
            props: route => ({ id: route.params.id }),
            meta: { requiresAuth: true, requiresAdmin: true }
          },
          {
            path: 'hotels',
            name: 'AdminHotels',
            component: HotelList,
            meta: { requiresAuth: true, requiresAdmin: true }
          },
          {
            path: 'hotels/create',
            name: 'AdminHotelCreate',
            component: HotelForm,
            meta: { requiresAuth: true, requiresAdmin: true }
          },
          {
            path: 'hotels/:id/edit',
            name: 'AdminHotelEdit',
            component: HotelForm,
            props: route => ({ id: route.params.id }),
            meta: { requiresAuth: true, requiresAdmin: true }
          },
          {
            path: 'services',
            name: 'AdminServices',
            component: ServiceList,
            meta: { requiresAuth: true, requiresAdmin: true }
          },
          {
            path: 'services/create',
            name: 'AdminServiceCreate',
            component: ServiceForm,
            meta: { requiresAuth: true, requiresAdmin: true }
          },
          {
            path: 'services/:id/edit',
            name: 'AdminServiceEdit',
            component: ServiceForm,
            props: route => ({ id: route.params.id }),
            meta: { requiresAuth: true, requiresAdmin: true }
          },
          {
            path: 'product-services',
            name: 'AdminProductService',
            component: ProductServiceList,
            meta: { requiresAuth: true, requiresAdmin: true }
          },
          {
            path: 'product-services/create',
            name: 'AdminProductServiceCreate',
            component: ProductServiceCreate,
            meta: { requiresAuth: true, requiresAdmin: true }
          },
          {
            path: 'product-services/edit/:id',
            name: 'AdminProductServiceEdit',
            component: ProductServiceCreate,
            meta: { requiresAuth: true, requiresAdmin: true }
          },
          {
            path: 'actions',
            name: 'ActionIndex',
            component: ActionIndex,
            meta: { requiresAuth: true, requiresAdmin: true }
          },
          {
            path: 'actions/create',
            name: 'ActionCreate',
            meta: { requiresAuth: true, requiresAdmin: true },
            component: ActionCreate
          },
          {
            path: 'actions/edit/:id',
            name: 'ActionEdit',
            meta: { requiresAuth: true, requiresAdmin: true },
            component: ActionEdit,
            props: true
          },
          {
            path: 'integrations',
            name: 'Integrations',
            meta: { requiresAuth: true, requiresAdmin: true },
            component: Integrations,
          },
          {
            path: 'integrations/create',
            name: 'IntegrationCreate',
            meta: { requiresAuth: true, requiresAdmin: true },
            component: IntegrationCreate,
          },
          {
            path: '/integrations/edit/:id?',
            name: 'IntegrationUpdate',
            meta: {
              authRequired: false,
            },
            props: true,
            component: IntegrationUpdate
          },
          {
            path: '/integration/users/:integration_id?',
            name: 'IntegrationUsers',
            meta: {
              authRequired: false,
            },
            props: true,
            component: IntegrationUsers
          },
          {
            path: 'customers',
            name: 'Customers',
            component: CustomerList,
            meta: { requiresAuth: true, requiresAdmin: true }
          },
          {
            path: 'action-user/create/:id?',
            name: 'ActionUserCreate',
            meta: { requiresAuth: true, requiresAdmin: true },
            component: ActionUserCreate
          },
          {
            path: 'pre-checkin/thank-you',
            name: 'PreCheckinThankYou',
            component: PreCheckinThankYou,
            meta: { layout: 'none' }
          },
          {
            path: 'booking/create',
            name: 'BookingPreCheckin',
            component: AddBooking,
            meta: { requiresAuth: true, requiresAdmin: true }
          },
          {
            path: 'booking',
            name: 'Bookings',
            component: Bookings,
            meta: { requiresAuth: true, requiresAdmin: true }
          },
          {
            path: 'room-availabilites',
            name: 'RoomAvailability',
            component: RoomAvailability,
            meta: { requiresAuth: true, requiresAdmin: true }
          },
          {
            path: 'room-availabilites/create',
            name: 'AddRoomAvailability',
            component: AddRoomAvailability,
            meta: { requiresAuth: true, requiresAdmin: true }
          },
          {
            path: 'room-availabilites/:id/edit',
            name: 'EditRoomAvailability',
            component: EditRoomAvailability,
            meta: { requiresAuth: true, requiresAdmin: true }
          },
          {
            path: 'coupon',
            name: 'Coupon',
            component: Coupon,
            meta: { requiresAuth: true, requiresAdmin: true }
          },
          {
            path: 'coupon/create',
            name: 'AddCoupon',
            component: AddCoupon,
            meta: { requiresAuth: true, requiresAdmin: true }
          },
          {
            path: 'coupon/:id/edit',
            name: 'EditCoupon',
            component: EditCoupon,
            meta: { requiresAuth: true, requiresAdmin: true }
          },
          {
            path: 'offers',
            name: 'Offers',
            component: OfferList,
            meta: { requiresAuth: true, requiresAdmin: true }
          },
          {
            path: 'offers/create',
            name: 'CreateOffer',
            component: OfferForm,
            meta: { requiresAuth: true, requiresAdmin: true }
          },
          {
            path: 'offers/:id',
            name: 'OfferDetail',
            component: OfferDetail,
            props: route => ({ id: route.params.id }),
            meta: { requiresAuth: true, requiresAdmin: true }
          },
          {
            path: 'offers/:id/edit',
            name: 'EditOffer',
            component: OfferForm,
            props: route => ({ id: route.params.id }),
            meta: { requiresAuth: true, requiresAdmin: true }
          },
          {
            path: 'pre-checkin-offers',
            name: 'PreCheckinOffers',
            component: PreCheckinOffersList,
            meta: { requiresAuth: true, requiresAdmin: true }
          },
          {
            path: 'room-types',
            name: 'AdminRoomTypes',
            component: RoomTypeList,
            meta: { requiresAuth: true, requiresAdmin: true }
          },
          {
            path: 'room-types/create',
            name: 'AdminRoomTypeCreate',
            component: RoomTypeForm,
            meta: { requiresAuth: true, requiresAdmin: true }
          },
          {
            path: 'room-types/:id/edit',
            name: 'AdminRoomTypeEdit',
            component: RoomTypeForm,
            props: route => ({ id: route.params.id }),
            meta: { requiresAuth: true, requiresAdmin: true }
          },
          {
            path: 'room-types/:id/rooms/create',
            name: 'CreateRoom',
            component: CreateRoom,
            meta: { requiresAuth: true, requiresAdmin: true }
          },
          {
            path: 'room-types/:id/rooms',
            name: 'RoomTypeRooms',
            component: Rooms,
            meta: { requiresAuth: true, requiresAdmin: true }
          },
          {
            path: 'room-types/:id/rooms/:room_id/edit',
            name: 'EditRoomTypeRoom',
            component: EditRoom,
            meta: { requiresAuth: true, requiresAdmin: true }
          },
          {
            path: 'bed-sizes',
            name: 'AdminBedSizes',
            component: BedSizeList,
            meta: { requiresAuth: true, requiresAdmin: true }
          },
          {
            path: 'bed-sizes/create',
            name: 'AdminBedSizeCreate',
            component: BedSizeForm,
            meta: { requiresAuth: true, requiresAdmin: true }
          },
          {
            path: 'bed-sizes/:id/edit',
            name: 'AdminBedSizeEdit',
            component: BedSizeForm,
            props: route => ({ id: route.params.id }),
            meta: { requiresAuth: true, requiresAdmin: true }
          },
          {
            path: 'facilities',
            name: 'AdminFacilities',
            component: FacilityList,
            meta: { requiresAuth: true, requiresAdmin: true }
          },
          {
            path: 'facilities/create',
            name: 'AdminFacilityCreate',
            component: FacilityForm,
            meta: { requiresAuth: true, requiresAdmin: true }
          },
          {
            path: 'facilities/:id/edit',
            name: 'AdminFacilityEdit',
            component: FacilityForm,
            props: route => ({ id: route.params.id }),
            meta: { requiresAuth: true, requiresAdmin: true }
          },
          {
            path: 'room-facilities',
            name: 'AdminRoomFacilities',
            component: RoomFacilityList,
            meta: { requiresAuth: true, requiresAdmin: true }
          },
          {
            path: 'room-facilities/create',
            name: 'AdminRoomFacilityCreate',
            component: RoomFacilityForm,
            meta: { requiresAuth: true, requiresAdmin: true }
          },
          {
            path: 'room-facilities/:id/edit',
            name: 'AdminRoomFacilityEdit',
            component: RoomFacilityForm,
            props: route => ({ id: route.params.id }),
            meta: { requiresAuth: true, requiresAdmin: true }
          },
          {
            path: 'hotel-facilities',
            name: 'AdminHotelFacilities',
            component: HotelFacilityList,
            meta: { requiresAuth: true, requiresAdmin: true }
          },
          {
            path: 'hotel-facilities/create',
            name: 'AdminHotelFacilityCreate',
            component: HotelFacilityForm,
            meta: { requiresAuth: true, requiresAdmin: true }
          },
          {
            path: 'hotel-facilities/:id/edit',
            name: 'AdminHotelFacilityEdit',
            component: HotelFacilityForm,
            props: route => ({ id: route.params.id }),
            meta: { requiresAuth: true, requiresAdmin: true }
          },
          {
            path: 'hotel-group',
            name: 'HotelGroupList',
            component: HotelGroupList,
            meta: { requiresAuth: true, requiresAdmin: true }
          },
          {
            path: 'hotel-group/create',
            name: 'AddHotelGroup',
            component: HotelGroupForm,
            meta: { requiresAuth: true, requiresAdmin: true }
          },
          {
            path: 'hotel-group/:id/edit',
            name: 'EditHotelGroup',
            component: HotelGroupForm,
            props: route => ({ id: route.params.id }),
            meta: { requiresAuth: true, requiresAdmin: true }
          },
          {
            path: 'reports',
            name: 'Report',
            component: ReportsIndex,
            meta: { requiresAuth: true, requiresAdmin: true }
          },
          {
            path: 'billing',
            name: 'AdminBilling',
            component: BillingList,
            meta: { requiresAuth: true, requiresAdmin: true }
          },
          {
            path: "pre-check-in/chat",
            name: "AdminPreCheckinChat",
            component: PreCheckinChat,
            meta: { requiresAuth: true, requiresAdmin: true },
          },
          {
            path: 'booking.com',
            name: 'booking.comBookings',
            component: bookingcom,
            meta: { requiresAuth: true, requiresAdmin: true }
          },
          {
            path: 'departments',
            name: 'AdminDepartments',
            component: DepartmentList,
            meta: { requiresAuth: true, requiresAdmin: true }
          },
          {
            path: 'departments/create',
            name: 'AdminDepartmentCreate',
            component: DepartmentForm,
            meta: { requiresAuth: true, requiresAdmin: true }
          },
          {
            path: 'departments/:id/edit',
            name: 'AdminDepartmentEdit',
            component: DepartmentForm,
            props: route => ({ id: route.params.id }),
            meta: { requiresAuth: true, requiresAdmin: true }
          },
          {
            path: 'staff',
            name: 'AdminStaff',
            component: StaffList,
            meta: { requiresAuth: true, requiresAdmin: true }
          },
          {
            path: 'staff/create',
            name: 'AdminStaffCreate',
            component: StaffForm,
            meta: { requiresAuth: true, requiresAdmin: true }
          },
          {
            path: 'staff/:id/edit',
            name: 'AdminStaffEdit',
            component: StaffForm,
            props: route => ({ id: route.params.id }),
            meta: { requiresAuth: true, requiresAdmin: true }
          },
          {
            path: "notifications",
            name: "adminNotifications",
            component: NotificationsList,
            meta: {
              requiresAuth: true,
              title: "notifications"
            }
          },
    ]
  },
  {
    path: '/invitation/respond',
    name: 'InvitationResponse',
    component: InvitationResponse,
    meta: { requiresAuth: false }
  },
  {
    path: '/',
    component: UserLayout,
    children: [
      { path: '', component: UserHome, name:"UserHome" },
      { path: 'hotels', component: UserHotels },
      { path: 'hotels/:id', component: UserHotelDetails, name:"HotelDetail" },
      { path: 'bookings', component: UserBookings, meta: { requiresAuth: true } },
      { path: 'about', component: AboutUs },
      { path: 'contact', component: ContactUs },
      { path: 'privacy', component: PrivacyPolicy },
      {
          path: 'offer',
          name: 'OffersPage',
          component: () => import('@/views/user/Offer'),
      },
      {
        path: 'profile',
        name: 'UserProfile',
        component: () => import('@/views/user/profile.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'hotel-availability',
        name: 'UserHotelAvailability',
        component: () => import('@/views/user/HotelAvailability.vue'),
        meta: { requiresAuth: false }
      },
      {
        path: 'booking',
        name: 'UserBooking',
        component: () => import('@/views/user/Booking.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: "pre-check-in/chat",
        name: "PreCheckinChat",
        component: PreCheckinChat,
        meta: { requiresAuth: true },
      },
      {
        path: 'signup',
        name: 'UserSignup',
        component: () => import('@/views/user/Signup.vue'),
        meta: { requiresAuth: false }
      },
    ]
  },
  {
    path: '/unauthorized',
    alias: '/403',
    name: 'UnauthorizedView',
    component: () => import('@/views/Unauthorized.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/404',
    name: '404',
    component: () => import('@/views/404.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/staff/dashboard',
    name: 'StaffDashboard',
    component: StaffDashboard,
    meta: { requiresStaffAuth: true, layout: 'none' }
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
// Navigation guard
router.beforeEach((to, from, next) => {
  const isAuthenticated = !!hasAuthUser();
  const requiresAuth = to.matched.some(r => r.meta?.requiresAuth);
  if (to.matched.length === 0) {
    next({ path: '/404' });
  }
  // Regular authentication check
  if (requiresAuth && !isAuthenticated) {
    next({
      name:"Login",
      query: { redirect: to.fullPath }
    });
  }else if (isAuthenticated) {
    const user      = store.getters?.user || getAuthUser();
    const userRole  = user.role;
    if(['/login','/signup'].includes(to.path)){
      if (['super_admin', 'admin', 'brand_admin', 'account_admin'].includes(userRole)) {
        next('/admin/dashboard');
      }
      next({name:"UserHome"});
    }else{
      if (['super_admin', 'admin', 'brand_admin', 'account_admin'].includes(userRole)) {
        const allowedRoutes = navigationItems[userRole] || [];
        const isAllowed = allowedRoutes.some(navItem => to.path.startsWith(navItem.path));

        if (isAllowed) {
          next();
        } else {
          next({name:"AdminDashboard"})
        }
      }else{
        if (to.path.startsWith('/admin')) {
          next({ path: '/403' });
        }
        next();
      }
    }
  }else{
    next();
  }
});



export default router
